module.exports = __webpack_public_path__ + "img/background15.cae33cba.jpg";